import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.985 12.522a9 9 0 1 0 -8.475 8.464","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}],["path",{"d":"M19 16v6","key":"svg-2"}]]

const IconCirclePlus2 = createReactComponent('outline', 'circle-plus-2', 'CirclePlus2', __iconNode);

export default IconCirclePlus2;